"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFormResponseAce = instanceOfFormResponseAce;
exports.FormResponseAceFromJSON = FormResponseAceFromJSON;
exports.FormResponseAceFromJSONTyped = FormResponseAceFromJSONTyped;
exports.FormResponseAceToJSON = FormResponseAceToJSON;
exports.FormResponseAceToJSONTyped = FormResponseAceToJSONTyped;
var FormResponse_1 = require("./FormResponse");
var ArchetypeIndex_1 = require("./ArchetypeIndex");
var FormSection_1 = require("./FormSection");
var EmbeddableSid_1 = require("./EmbeddableSid");
var PermissionLevel_1 = require("./PermissionLevel");
/**
 * Check if a given object implements the FormResponseAce interface.
 */
function instanceOfFormResponseAce(value) {
    return true;
}
function FormResponseAceFromJSON(json) {
    return FormResponseAceFromJSONTyped(json, false);
}
function FormResponseAceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'sid': json['sid'] == null ? undefined : (0, EmbeddableSid_1.EmbeddableSidFromJSON)(json['sid']),
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
        'granting': json['granting'] == null ? undefined : json['granting'],
        'permissionLevel': json['permissionLevel'] == null ? undefined : (0, PermissionLevel_1.PermissionLevelFromJSON)(json['permissionLevel']),
        'archetype': json['archetype'] == null ? undefined : (0, ArchetypeIndex_1.ArchetypeIndexFromJSON)(json['archetype']),
        'andArchetype': json['andArchetype'] == null ? undefined : (0, ArchetypeIndex_1.ArchetypeIndexFromJSON)(json['andArchetype']),
        'acl': json['acl'] == null ? undefined : (0, FormResponse_1.FormResponseFromJSON)(json['acl']),
        'section': json['section'] == null ? undefined : (0, FormSection_1.FormSectionFromJSON)(json['section']),
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function FormResponseAceToJSON(json) {
    return FormResponseAceToJSONTyped(json, false);
}
function FormResponseAceToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'sid': (0, EmbeddableSid_1.EmbeddableSidToJSON)(value['sid']),
        'permissions': value['permissions'],
        'granting': value['granting'],
        'permissionLevel': (0, PermissionLevel_1.PermissionLevelToJSON)(value['permissionLevel']),
        'archetype': (0, ArchetypeIndex_1.ArchetypeIndexToJSON)(value['archetype']),
        'andArchetype': (0, ArchetypeIndex_1.ArchetypeIndexToJSON)(value['andArchetype']),
        'acl': (0, FormResponse_1.FormResponseToJSON)(value['acl']),
        'section': (0, FormSection_1.FormSectionToJSON)(value['section']),
        'illegal': value['illegal'],
    };
}
